import { render, staticRenderFns } from "./HourBlock.vue?vue&type=template&id=56c16ecf&scoped=true&"
import script from "./HourBlock.vue?vue&type=script&lang=js&"
export * from "./HourBlock.vue?vue&type=script&lang=js&"
import style0 from "./HourBlock.vue?vue&type=style&index=0&id=56c16ecf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c16ecf",
  null
  
)

export default component.exports